<template>
  <div class="col-md-6 d-flex col-inline-block">
    <div class="card flex-grow-1 mb-md-0 mr-0 mr-lg-3 ml-0 ml-lg-4">
      <div class="card-body card-body--padding--2">
        <h3 class="card-title">Log In</h3>
        <form>
          <base-spinner :open="isloading"></base-spinner>
          <!-- <base-message
          v-if="!isloading"
          :servermessages="servermessages"
          ></base-message> -->
          <div class="col-12 col-md-12 p-0" v-if="servermessages.length > 0">
              <div class="alert alert-danger mb-3">
                  <!-- <strong>Please correct all of the errors listed below before proceding. <br/></strong> -->
                  <strong v-for="message in servermessages" :key="message">
                      {{ message }} <br/>
                  </strong> 
              </div>
          </div>
          <div class="form-group" :class="{ invalid: userValid === 'invalid' }">
            <label for="signin-userid">User</label>
            <input
              id="signin-userid"
              type="text"
              class="form-control"
              placeholder="user"
              v-model.trim="user"
              @blur="validateUser"
              @keypress.enter="login"
            />
            <small class="invalid-text" v-if="userValid === 'invalid'">
                                <i>Please enter a valid user name.</i>  
                            </small>
          </div>
          <div class="form-group has-icon" :class="{ invalid: passValid === 'invalid' }">
                <base-password-input
                  v-model="password"
                  placeholder="Password"
                  @validate-input="validatePass"
                >
                  <template #message>
                    <small class="invalid-text" v-if="passValid === 'invalid'">
                      <i>Please enter a valid password.</i>
                    </small>

                  </template>
                </base-password-input>
            <small class="form-text text-muted">
              <a href="#" @click.prevent="forgotPasswordClicked">Forgot password?</a>
            </small>
          </div>
          <div class="form-group">
            <div class="form-check">
              <span class="input-check form-check-input">
                <span class="input-check__body">
                  <input
                    class="input-check__input"
                    type="checkbox"
                    id="signin-remember"
                  />
                  <span class="input-check__box"></span>
                  <span class="input-check__icon">
                    <svg width="9px" height="7px">
                      <path
                        d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z"
                      ></path>
                    </svg>
                  </span>
                </span>
              </span>
              <label class="form-check-label" for="signin-remember"
                >Remember Me</label
              >
            </div>
          </div>
          <div class="form-group mb-0">
            <button type="button" class="btn btn-primary mt-3" @click="login">
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <base-dialog title="Forgot Password" @close="cancelForgotPass" :open="forgotPassModalOpen">
    <template #default>
      <div class="form-group has-icon" :class="{ invalid: emailValid === 'invalid' }">
        <input type="text" class="form-control" v-model="userid" placeholder="User ID or Phone Number" size="40" required="true" />
        <small class="invalid-text" v-if="emailValid === 'invalid'">
            <i>Please enter User ID or Phone number.</i>  
        </small>
      </div>
    </template>
    <template #actions>
      <div class="text-right">
        <button type="button" class="btn btn-primary mr-3" @click="confirmForgotPass">
          Confirm
        </button>       
        <button type="button" class="btn btn-grey" @click="cancelForgotPass">
          Cancel
        </button>   
      </div>
    </template>
  </base-dialog>

  <base-dialog title="Change Password" :showClose="false" :open="changePassModalOpen">
    <template #default>
      <base-message
      v-if="!isloading"
      :servermessages="changepassmessages"
      ></base-message>
      <div class="dialog-change-password-container">
        <div
          class="form-group has-icon"
          :class="{ invalid: newpassvalid === 'invalid' }"
        >
          <label for="password-new">New Password</label>
          <base-password-input
            size="30"
            v-model="newpass"
            placeholder="New Password"
            :eyeid="'pass-status-new'"
            :eyecontainerclass="'eye-container-new-pw'"
            @validate-input="validateNewPass"
          >
            <template #message>
              <small class="invalid-text" v-if="newpassvalid === 'invalid'">
                <i>Please enter a new password.</i>
              </small>
            </template>
          </base-password-input>
        </div>
        <div
          class="form-group has-icon"
          :class="{ invalid: verifypassvalid === 'invalid' }"
        >
          <label for="password-confirm">Repeat New Password</label>
          <base-password-input
            size="30"
            v-model="verifypass"
            placeholder="Repeat New Password"
            :eyeid="'pass-status-confirm'"
            :eyecontainerclass="'eye-container-new-pw-repeat'"
            @validate-input="validateVerifyPass"
          >
            <template #message>
              <small
                class="invalid-text"
                v-if="verifypassvalid === 'invalid'"
              >
                <i>Please enter verify your new password.</i>
              </small>
            </template>

          </base-password-input>
        </div>
      </div>
    </template>
    <template #actions>
      <div class="text-right">
        <button type="button" class="btn btn-primary" @click="confirmChangePass">
          Change
        </button>         
      </div>
    </template>
  </base-dialog>

</template>

<script>
import MixinCustomer from '../../../mixins/customer.js'
import axiosvl from "../../../axios/axios-vl.js";

export default {
    mixins: [
        MixinCustomer
    ],
  data() {
    return {
      user: "",
      password: "",
      userValid: "pending",
      passValid: "pending",
      emailValid: "pending",
      userid: '',
      forgotPassModalOpen: false,
      newpassvalid: "pending",
      verifypassvalid: "pending",
      newpass: "",
      verifypass: "",
      changePassModalOpen: false,
      servermessages: [],
      changepassmessages: [],
      serverstatus: "",
      isloading: false,
      customerIndicator: 'C',
      CMPORQ: '',
    };
  },
  methods: {
    validateUser() {
      if (this.user === "") {
        this.userValid = "invalid";
      } else {
        this.userValid = "valid";
      }
    },
    validatePass() {
      if (this.password === "") {
        this.passValid = "invalid";
      } else {
        this.passValid = "valid";
        this.login();
      }
    },
    login() {
      this.isloading = true;
      this.servermessages, this.serverstatus, (this.servermessages = []);
      const login_uri = this.$store.getters['api/login_uri'];
      axiosvl.post(login_uri,
          {
            webroutine: {
              context: {
                "session-key-method": "hidden",
              },
              fields: {
                // "HOSTURL": { "value": this.$store.getters.hosturl },
                "LW3SFID": { "value": this.$store.getters.storefront },
                "LW3WEBUSR": { "value": this.user },
                "LW3USRPAS": { "value": this.password }
              },
            },
          }
        )
        .then((response) => {
          const fields = response.data.webroutine.fields;

          this.serverstatus = fields.LW3RETCOD.value;

          if (this.serverstatus === "OK") {
            this.userValid, (this.passValid = "pending");

            let userattributes = [];
          
            // set customer/user attributes based on it's settings
            for (const key in response.data.webroutine.lists.LS_USERATTRIBUTES.entries) {
                const obj = response.data.webroutine.lists.LS_USERATTRIBUTES.entries[key];
                userattributes.push({
                    id: obj.LW3UATID,
                    type: obj.LW3UATTY,
                    sequence: obj.LW3UATSQ,
                    desc: obj.LW3UATDS,
                    language: obj.LW3LNGCOD,
                    value: obj.LW3UATVL,
                    displaySequence: obj.LW3UADSQ,
                });
            }
            // save the attributes on the state
            this.$store.dispatch("setUserAttributes", userattributes);
            // save login user indicator and id
            this.$store.dispatch("login", {
                isAuth: true,
                userid: fields.LW3WEBUSR.value,
                customer: fields.LW3WEBC01.value,
                customerIndicator: fields.LW3CUSIND.value
            });

            this.customerIndicator = fields.LW3CUSIND.value;

            // fetch seprately the customer information via web service
            this.mx_getCustomerInformation();

            this.isloading = false;

            // this.getCustomerInfo();

            if (fields.LW3CHPASF.value === 'Y') {
              // Change Password Flag is set to "Y"
              this.changePassModalOpen = true;
            } else {
              this.password = "";
              // this.$router.push("/home");
              // router go back to the previous page
              this.$router.go(-1);
            }
            
          } else {
            const messages = [];
            const wrmessages = response.data.webroutine.messages;

            for (var i = 0; i < wrmessages.length; i++) {
              messages.push(wrmessages[i]);
            }

            // Return code is not "OK" but no messages appear, add a custom error message
            if (messages.length === 0) {
              messages.push("Something went wrong. Please try again later.");
            }

            this.password = "";
            this.isloading = false;
            this.servermessages = messages;            
          }

          
        })
        .catch((error) => {
          this.servermessages.push(
            "Something went wrong. Please try again later."
          );
          this.password = "";
          this.isloading = false;
          console.log("error - " + error);
        });
    },
    validateEmail() {
      if (this.userid === "") {
        this.emailValid = "invalid";
      } else {
        if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.userid)) {
          this.emailValid = "valid";
        } else {
          this.emailValid = "invalid";
        }
      }
    },
    forgotPasswordClicked() {
      this.forgotPassModalOpen = true;
    },
    confirmForgotPass() {
      this.isloading = true;
      this.servermessages, this.serverstatus, (this.servermessages = []);

      axiosvl.post(this.$store.getters['api/forgot_password_uri'],
        {
          webroutine: {
            context: {
              "session-key-method": "hidden",
            },
            fields: {
              // "HOSTURL"   : { "value": this.$store.getters.hosturl },
              "LW3SFID": { "value": this.$store.getters.storefront },
              "LW3WEBC01" : { "value": this.userid },
            },
          },
        }
        )
        .then((response) => {
        
          const messages = [];
          const wrmessages = response.data.webroutine.messages;

          for (var i = 0; i < wrmessages.length; i++) {
            messages.push(wrmessages[i]);
          }

          // Return code is not "OK" but no messages appear, add a custom error message
          if (messages.length === 0) {
            messages.push("Something went wrong. Please try again later.");
          }

          this.forgotPassModalOpen = false;
          this.isloading = false;
          this.servermessages = messages;  

        })
        .catch((error) => {
          this.servermessages.push(
            "Something went wrong. Please try again later."
          );
          this.isloading = false;
          console.log("error - " + error);
        });
    },
    cancelForgotPass() {
      this.forgotPassModalOpen = false;
    },
    validateNewPass() {
      if (this.newpass === "") {
        this.newpassvalid = "invalid";
      } else {
        this.newpassvalid = "valid";
      }
    },
    validateVerifyPass() {
      if (this.verifypass === "") {
        this.verifypassvalid = "invalid";
      } else {
        this.verifypassvalid = "valid";
      }
    },
    confirmChangePass() {
      this.changepassmessages = [];
      axiosvl.post(this.$store.getters['api/change_password_uri'],
          {
            webroutine: {
              context: {
                "session-key-method": "hidden",
              },
              fields: {
                // "HOSTURL": { "value": this.$store.getters.hosturl },
                "LW3SFID": { "value": this.$store.getters.storefront },
                "LW3WEBUSR": { "value": this.$store.getters.userid },
                "LW3USRPAS": { "value": this.password },
                "LW3USRNPW": { "value": this.newpass },
                "LW3USRPS2": { "value": this.verifypass }
              },
            },
          }
      )
      .then((response) => {
        this.isloading = false;
        const fields = response.data.webroutine.fields;

        const messages = [];
        const wrmessages = response.data.webroutine.messages;

        for (var i = 0; i < wrmessages.length; i++) {
          messages.push(wrmessages[i]);
        }

        if (fields.LW3RETCOD.value === "OK") {
          this.password = '', this.newpass = '', this.verifypass = '';
          this.$router.push("/home");

        } else {
          if (messages.length === 0) {
            messages.push("Something went wrong. Please try again later.");
          }
        }  

        this.changepassmessages = messages;
      })
      .catch((error) => {
        this.servermessages.push(
          "Something went wrong. Please try again later."
        );
        this.isloading = false;
        console.log("error - " + error);
      });
    },
    getCustomerInfo() {
        this.isloading = true;
        this.servermessages = [];

        this.billingname = '', this.billingaddress1 = '', this.billingaddress2 = '', this.billingcity = '', this.billingstate = '', this.billingzip = '', this.billingphone = '', this.shippingname = '', this.shippingaddress1 = '', this.shippingaddress2 = '', this.shippingcity = '', this.shippingstate = '', this.shippingzip = '', this.shippingphone = '', this.customeremail = '';

        axiosvl.post(this.$store.getters['api/get_customer_info_uri'], {
            "webroutine": {
                "context": {
                    "session-key-method": "hidden"
                },
                "fields": {
                    "EHCUST": {"value": this.$store.getters.customer},
                }
            }
        })
        .then((response) => {
            const fields = response.data.webroutine.fields;

            let messages = [];
            
            if (fields.RESULTCOD.value === 'OK') {
                this.billingname = fields.ADNAME.value;
                this.billingaddress1 = fields.ADADD1.value;
                this.billingaddress2 = fields.ADADD2.value;
                this.billingcity = fields.ADCITY.value;
                this.billingstate = fields.ADSTTC.value;
                this.billingzip = fields.ADZIPC.value;
                this.billingphone = fields.ADPHON.value;
                this.CMNAME = fields.CMNAME.value;
                this.ADCNNM = fields.ADCNNM.value;
                this.S2CNNM = fields.S2CNNM.value;
                this.CMPORQ = fields.CMPORQ.value;

                this.$store.dispatch('cart/po_required', {
                  po_required : this.CMPORQ
                });

                console.log('carrier = ' + fields.CMCARR.value);

                this.$store.dispatch('cart/carrier', {
                  carrier : fields.CMCARR.value
                  // carrier : "UPS-1"
                });

                this.$store.dispatch('cart/billingdetails', {
                    "billingname": this.billingname,
                    "billingaddress1": this.billingaddress1,
                    "billingaddress2": this.billingaddress2,
                    "billingcity": this.billingcity,
                    "billingstate": this.billingstate,
                    "billingzip": this.billingzip,
                    "billingphone": this.billingphone,
                });

                if (fields.S2NAME.value === '' && fields.S2ADD1.value === '') {
                    this.shippingname = fields.ADNAME.value;
                    this.shippingaddress1 = fields.ADADD1.value;
                    this.shippingaddress2 = fields.ADADD2.value;
                    this.shippingcity = fields.ADCITY.value;
                    this.shippingstate = fields.ADSTTC.value;
                    this.shippingzip = fields.ADZIPC.value;
                    this.shippingphone = fields.ADPHON.value;
                } else {
                    this.shippingname = fields.S2NAME.value;
                    this.shippingaddress1 = fields.S2ADD1.value;
                    this.shippingaddress2 = fields.S2ADD2.value;
                    this.shippingcity = fields.S2CITY.value;
                    this.shippingstate = fields.S2STTC.value;
                    this.shippingzip = fields.S2ZIPC.value;
                    this.shippingphone = fields.S2PHON.value;
                }

                this.defaultcarrier = fields.CMCARR.value;
                this.requirespo = fields.CMPORQ.value;
                this.customeremail = fields.ECEMAL.value;

                if (this.customerIndicator == 'C'){
                  this.getTaxRate();
                }
            } else {
                const wrmessages = response.data.webroutine.messages;

                for (var i = 0; i < wrmessages.length; i++) {
                    messages.push(wrmessages[i]);
                }

                // Return code is not "OK" but no messages appear, add a custom error message
                if (messages.length === 0) {
                    messages.push("Something went wrong. Please try again later.");
                }
            }

            this.isloading = false;
            this.servermessages = messages;
        })
        .catch((error) => {
            this.isloading = false;
            console.log("error - " + error);
        });
    },

    getTaxRate(){

			if(!this.billingzip || !this.billingstate){
				return false;
			}
			const tax_rate_uri = this.$store.getters['api/tax_rate_uri'];
      const params = {
          "webroutine": {
              "context": {
                  "session-key-method": "hidden"
              },
              "fields": {
                  // "HOSTURL": {"value": this.$store.getters.hosturl},
                  "LW3SFID": { "value": this.$store.getters.storefront },
                  "LW3TZIPCD": {
                      "value": this.billingzip
                  },
                  "LW3TXSTAT": {
                      "value": this.billingstate
                  },
              }
          }
      };

      axiosvl.post(tax_rate_uri, params)
      .then((response) => {
          const fields = response.data.webroutine.fields
          this.tax_rate = parseFloat(fields.LW3TXRATE.value) + 1;

          this.$store.dispatch("cart/update_tax_rate", {tax_rate : fields.LW3TXRATE.value});
          console.log(this.totals);

          if(this.totals !== undefined){
            const with_tax = parseFloat(this.totals[0].ordertotal) * this.tax_rate;
            const tax_amount = with_tax - parseFloat(this.totals[0].ordertotal);

            this.totals[0].taxtotal = tax_amount;
            this.totals[0].ordertotal = with_tax;
            this.$store.dispatch("cart/totals", this.totals[0]);
          }
          
      })
      .catch((error) => {
          // this.isloading = false;
          console.log("error - " + error);
      });
    }
  },
  created() {
    this.$ga.page({
        page: this.$route.fullPath,
        title: this.$route.name,
    });
  }
};
</script>

<style scoped>
.form-group.has-icon {
  position: relative;
}

.form-group.invalid input,
.form-group.invalid label {
  border-color: #cb1818;
}

.form-group.invalid label,
.form-group.invalid .invalid-text {
  color: #cb1818;
}

.dialog-change-password-container {
  width: 400px;
}

.col-inline-block {
  display: inline-block !important;
  text-align: left;
}

</style>